module.exports = __webpack_public_path__ + "img/donations.01eac203.png";